export default [{
  url: '/where-to-buy/residential',
  redirectUrl: '/find-a-rep/residential'
}, {
  url: '/where-to-buy/commercial',
  redirectUrl: '/find-a-rep/commercial'
}];